module.exports = __webpack_public_path__ + "img/我的选中.ae485b60.png";